import { connect } from 'react-redux';
import { showMobileMenu } from '../../state/actions/mobileMenuActions';

// Components
import MobileMenuButton from './MobileMenuButton';

export default connect(null, { showMobileMenu })(MobileMenuButton);